function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.896 1.38l-1.898 11.171 2.869 5.74a4.035 4.035 0 005.801 4.436C32.285 27.573 36.754 34.893 44.573 55l3.351-2.234c-3.15-11.141-7.819-21.224-12.379-28.245 1.277-1.533 1.277-1.445 1.312-2.812l-2.35 1.601c-2.038-2.339-3.504-3.899-3.657-4.16a4.035 4.035 0 00-5.408-3.795c-.536-2.108-.993-3.059-1.18-5.893-1.52-1.379-.913-3.614-.638-4.256 0 0-.412-2.639-.61-3.825zm4.852 16.534a1.117 1.117 0 01.064 0 1.117 1.117 0 011.117 1.117 1.117 1.117 0 01-1.117 1.117 1.117 1.117 0 01-1.118-1.117 1.117 1.117 0 011.054-1.117z",
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M28.183 15.355c.536-2.108.993-3.06 1.18-5.893 1.52-1.379.912-3.614.637-4.257 0 0 .413-2.638.611-3.824h1.117l1.899 11.17-2.87 5.74c.062.283.092.57.092.858m-2.133 3.556a4.04 4.04 0 01-3.76.022C21.34 27.573 16.87 34.893 9.051 55L5.7 52.766c3.15-11.14 7.82-21.224 12.379-28.245-1.277-1.533-1.276-1.444-1.311-2.811l2.35 1.6c2.038-2.339 3.503-3.898 3.656-4.16",
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgPliers = function SvgPliers(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPliers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Pliers.332200da.svg";
export { ForwardRef as ReactComponent };